import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export type AppNotification = {
  id: string;
  type: string;
  targetType: string;
  targetId: string | null;
  engagementId: string;
  title: string;
  message: string;
  actorDisplayName?: string | null;
  createdAt: string;
  isRead: boolean;
};

function authHeader(token: string | null) {
  if (!token) {
    throw new Error("No access token provided");
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export async function listNotifications(
  token: string | null,
  limit = 50,
  before?: string,
  beforeId?: string,
) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (before) {
    params.set("before", before);
    if (beforeId) params.set("beforeId", beforeId);
  }

  const response = await axios.get<AppNotification[]>(
    `${API_BASE_URL}/notifications?${params.toString()}`,
    authHeader(token),
  );
  return response.data;
}

export async function getUnreadNotificationCount(token: string | null) {
  const response = await axios.get<{ count: number }>(
    `${API_BASE_URL}/notifications/unread-count`,
    authHeader(token),
  );
  return response.data.count;
}

export async function setNotificationReadState(
  token: string | null,
  id: string,
  isRead: boolean,
) {
  await axios.post(
    `${API_BASE_URL}/notifications/${id}/${isRead ? "read" : "unread"}`,
    null,
    authHeader(token),
  );
}

export async function markAllNotificationsRead(token: string | null) {
  await axios.post(`${API_BASE_URL}/notifications/read-all`, null, authHeader(token));
}
